import {
  Grid,
  Typography,
  Paper,
  Button,
  Box,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Container,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import moment from "moment";
import ViewClientIntake from "./ViewClientIntake";
import { useApi } from "../../utils/api";
import Loading from "../Layout/Loading";
import { useAuth } from "../../utils/auth";
const ClientIntakes = () => {
  const { user } = useAuth();
  const { getClientIntakes, getUser, deleteClientIntake } = useApi();
  const [clientIntakes, setClientIntakes] = useState([]);
  const [selectedClientIntake, setSelectedClientIntake] = useState(null);
  const [loading, setLoading] = useState(true);
  const [openSendIntake, setOpenSendIntake] = useState(false);
  const [coach, setCoach] = useState(null);
  useEffect(() => {
    const fetch = async () => {
      const data = await getClientIntakes();
      const coachData = await getUser(user.uid);
      setCoach(coachData);
      setClientIntakes(data);
      setLoading(false);
    };
    fetch();
  }, [getClientIntakes, getUser, user]);

  const handleDeleteClientIntake = async (clientIntakeId) => {
    const response = await deleteClientIntake(clientIntakeId);
    if (response.success) {
      const data = await getClientIntakes();
      setClientIntakes(data);
    }
  };

  if (loading) {
    return (
      <Container sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
        <Loading />
      </Container>
    );
  }

  return (
    <Box sx={{ p: 2 }}>
      <Grid display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h6">Client Intakes</Typography>
        <Button onClick={() => setOpenSendIntake(true)}>Send Intake</Button>
      </Grid>
      {clientIntakes.map((clientIntake) => (
        <Paper sx={{ mt: 2, p: 2 }} key={clientIntake.id}>
          <Grid sx={{ mb: 1 }} display="flex" justifyContent="space-between">
            <Typography>
              <b>{clientIntake.fullname}</b>
            </Typography>
            <Typography>
              <b>{moment.unix(clientIntake.date).format("M/D/YYYY")}</b>
            </Typography>
          </Grid>

          <Typography sx={{ mb: 2 }}>{clientIntake.email}</Typography>
          <Button onClick={() => setSelectedClientIntake(clientIntake)}>
            View Client Intake
          </Button>
          <Button onClick={() => handleDeleteClientIntake(clientIntake.id)}>
            Delete
          </Button>
        </Paper>
      ))}
      {selectedClientIntake && (
        <ViewClientIntake
          clientIntake={selectedClientIntake}
          handleClose={() => setSelectedClientIntake(null)}
        />
      )}
      {openSendIntake && (
        <SendIntake onClose={() => setOpenSendIntake(false)} coach={coach} />
      )}
    </Box>
  );
};

const SendIntake = ({ onClose, coach }) => {
  const { sendEmail } = useApi();
  const [email, setEmail] = useState();
  const [name, setName] = useState();
  const { getUserId } = useAuth();
  const sendIntake = async () => {
    const response = await sendEmail({
      emailType: "CLIENT-INTAKE",
      sendEmail: email,
      name,
      coachId: btoa(getUserId()),
      coachName: coach.name,
    });
    if (response.success) {
      onClose();
    }
  };

  return (
    <Dialog open fullWidth>
      <DialogTitle>Send Intake</DialogTitle>
      <DialogContent>
        <TextField
          fullWidth
          value={name}
          onChange={(e) => setName(e.target.value)}
          label="Name"
          sx={{ mb: 2, mt: 1 }}
        />
        <TextField
          fullWidth
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          label="Email"
          sx={{ pt: 1 }}
        />
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={sendIntake}>
          Send
        </Button>
        <Button onClick={onClose}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ClientIntakes;
